var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1959 9.84544C12.2983 8.92828 13 7.54609 13 6C13 3.23858 10.7614 1 8 1C5.23858 1 3 3.23858 3 6C3 7.54609 3.70174 8.92828 4.80409 9.84544C4.92497 9.94602 5 10.0929 5 10.2501V13.5C5 14.3284 5.67157 15 6.5 15H9.5C10.3295 15 11 14.327 11 13.4996V10.2501C11 10.0929 11.075 9.94602 11.1959 9.84544ZM9.32565 8.69204C10.3177 8.20261 11.0001 7.18101 11.0001 6.00003C11.0001 4.34316 9.6569 3 8.00003 3C6.34316 3 5 4.34316 5 6.00003C5 7.18099 5.68238 8.20258 6.67436 8.69201C6.8644 8.78578 7 8.97102 7 9.18293V10H9V9.18295C9 8.97104 9.13561 8.7858 9.32565 8.69204ZM9 12H7V12.5C7 12.7761 7.22386 13 7.5 13H8.5C8.77614 13 9 12.7761 9 12.5V12Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/Lightbulb.bf4137d44a055776442b0bb49db942aa.svg";
export { ForwardRef as ReactComponent };